import { ContentCard } from "@msuite/ui/content-card";
import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import type { ProtocolFormSchema } from "@msuite/utils/schemas";
import { useFormContext, useWatch } from "react-hook-form";
import { useProtocolFormContext } from "./context";
import { ProtocolFormContentOptions } from "./protocol-form-content-options";
import { ProtocolFormContentSection } from "./protocol-form-content-section";

export function ProtocolFormContent() {
	/** Context */
	const methods = useFormContext<ProtocolFormSchema>();
	const [sections] = useWatch({ control: methods.control, name: ["content"] });
	const { hasType } = useProtocolFormContext();

	/** Hooks */
	const { t } = useTranslation();

	/** Guard */
	if (!hasType) return null;

	/** Render */
	return (
		<div className="v-stack gap-4">
			<ContentCard
				variant="plain"
				icon={icon("Text")}
				title={t("protocols.content")}
			>
				<div className="v-stack">
					{sections?.map((section, index) => (
						<ProtocolFormContentSection
							key={section.id}
							index={index}
							isLast={index === sections.length - 1}
							section={section}
						/>
					))}
					<ProtocolFormContentOptions />
				</div>
			</ContentCard>
		</div>
	);
}
